export default __webpack_public_path__ + "static/media/Logo_1.e1afa8bc.png";